// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\admin\\AppData\\Roaming\\npm\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n@media only screen and (max-width: 575px){\r\n    .page-wrapper .page-main-header .main-header-right .nav-right .profile-dropdown {\r\n        left: -125px !important;\r\n    }\r\n    \r\n}\r\n@media only screen and (max-width: 991px){\r\n\r\n.page-wrapper .page-main-header .main-header-right .nav-right .onhover-dropdown .onhover-show-div.profile-dropdown {\r\n   \r\n    margin-left: -65px !important;\r\n}\r\n}", ""]);
// Exports
module.exports = exports;
